import _ from "lodash";

import FeatureSwitchCheck from "./FeatureSwitchCheck";
import { UserType } from "types/Users";


type UserIdOrEmail = {
  userId?: number;
  email?: string;
};

export class UserInList extends FeatureSwitchCheck<UserIdOrEmail[], [ UserType | null | undefined ]> {

    protected parseFeatureValue(featureSwitchValue: string | undefined): UserIdOrEmail[] {
      const idsOrEmails: UserIdOrEmail[] = [];

      if (featureSwitchValue) {
        const userList = featureSwitchValue.split(',');
        for (const user of userList) {
          const userId = Number.parseInt(user);
          if (userId) {
            idsOrEmails.push({ userId });
          } else {
            idsOrEmails.push({ email: user });
          }
        }
      }

      return idsOrEmails;
    }

    protected doCheck(featureValue: UserIdOrEmail[], user: UserType | null | undefined): boolean {
      const wildcardEnabled = process.env.REACT_APP_FEATURE_SWITCH_WILDCARDS_ENABLED === "true"
        && _.some(featureValue, idOrEmail => idOrEmail.email === "*");

      if (featureValue.length === 0 || wildcardEnabled) {
        return true;
      } else {
        return _.some(featureValue, idOrEmail => (idOrEmail.userId === user?.id) || (idOrEmail.email === user?.email));
      }
    }

}
